import { render, staticRenderFns } from "./AdminTrialPanel.vue?vue&type=template&id=7b16990d&scoped=true"
import script from "./AdminTrialPanel.vue?vue&type=script&lang=js"
export * from "./AdminTrialPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminTrialPanel.vue?vue&type=style&index=0&id=7b16990d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16990d",
  null
  
)

export default component.exports